import { strCompareLowerCase } from "@common/Common";
import { ScoresExporterPreviewReadModel, ScoresExporterReadModel } from "@Evaluation/AlternativesSurveys/Domain/readmodels";

export class ScoresExporterViewModel
{
    opened: boolean = false;
    surveyId: number;
    initialized: boolean = false;

    preview: ScoresExporterPreviewReadModel | null = null;

    criteria: { Id: number, Path: string, Name: string, AttributeId?: number | null }[] = [];
    attributes: { Id: number, Name: string }[] = [];
    get alternatives() { return this.preview?.Alternatives; }

    show(surveyId: number)
    {
        this.surveyId = surveyId;
        this.preview = null;
        this.opened = true;
    }

    close()
    {
        this.opened = false;
        this.initialized = false;
        this.preview = null;
    }

    init(rm: ScoresExporterReadModel)
    {
        this.preview = null;
        this.criteria = rm.Criteria.map(c => { return { Id: c.Id, Path: c.Path, Name: c.Name, AttributeId: c.AttributeId } });
        this.attributes = rm.Attributes.map(a => { return { Id: a.Id, Name: a.Name } }).sort((a, b) => strCompareLowerCase(a.Name, b.Name));
        this.initialized = true;
    }

    setPreview(rm: ScoresExporterPreviewReadModel)
    {
        this.preview = rm;
    }
}
